import { createFileRoute } from '@tanstack/react-router';
import { WorksListPage } from '@/components/app/WorksListPage';

export const Route = createFileRoute('/app/works/')({
  component: WorksListPage,
});
